(function() {
    'use strict';

    angular.module('app').factory('SocketIOManager', SocketIOManager);

    SocketIOManager.$inject = [];

    function SocketIOManager() {
        const path = '/rest-api/messenger/io';
        let socket = null;

        return {
            get,
        };

        function get() {
            if (!socket) {
                console.log('socket-io-manager: create:', path);

                socket = io({ path });

                return socket;
            }

            socket.emit('server:remove');

            console.log('socket-io-manager: create: recreate');

            socket = io({ path });

            return socket;
        }
    }
})();
